__turbopack_context__.v({
  "container": "BoardsAlphabeticalFilter-module__F1QbQq__container",
  "fadeInItems": "BoardsAlphabeticalFilter-module__F1QbQq__fadeInItems",
  "filter": "BoardsAlphabeticalFilter-module__F1QbQq__filter",
  "filterActive": "BoardsAlphabeticalFilter-module__F1QbQq__filterActive",
  "filterInactive": "BoardsAlphabeticalFilter-module__F1QbQq__filterInactive",
  "spacing--lg": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--lg",
  "spacing--md": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--md",
  "spacing--sm": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--sm",
  "spacing--xl": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xl",
  "spacing--xs": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xs",
  "spacing--xxl": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xxl",
  "spacing--xxs": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xxs",
  "spacing--xxxl": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xxxl",
  "spacing--xxxs": "BoardsAlphabeticalFilter-module__F1QbQq__spacing--xxxs",
});
